module.exports = __webpack_public_path__ + "img/MascotAR-01.017b1806.png";